'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactChildrenUtilities = require('react-children-utilities');

var _reactChildrenUtilities2 = _interopRequireDefault(_reactChildrenUtilities);

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccordionGroup = function AccordionGroup(_ref) {
    var children = _ref.children,
        className = _ref.className;
    return _react2.default.createElement("ul", { className: (0, _classnames2.default)('luna-accordionGroup', className) }, _reactChildrenUtilities2.default.deepMap(children, function (child) {
        return child.type === _.Accordion ? _react2.default.cloneElement(child, { listItem: true }) : child;
    }));
};
AccordionGroup.propTypes = {
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)])
};
exports.default = AccordionGroup;
//# sourceMappingURL=AccordionGroup.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/AccordionGroup/AccordionGroup.js